import { date } from 'quasar';

/**
 * Validates if a date input is valid through JS native date parsing. This will
 * prevent date values over 31 but still allow days for months that do not have
 * them, eg: 20/02/2020
 *
 * @param inputDate The date to validate
 *
 * @returns {boolean} True if the date is valid
 */
export function isValidDate(inputDate) {
  return !isNaN(Date.parse(inputDate));
}

/**
 * Validates if a split date of day, month and year passes the standard JS date
 * validation as well as checking if the given date passes for the specific
 * given month.
 *
 * @param day The day of the date
 * @param month The month of the date
 * @param year The year of the date
 *
 * @returns {boolean} True if the date values make a valid date
 */
export function isValidDateStrict(day, month, year) {
  if (!day || !month || !year) {
    return false;
  }

  const newDate = new Date(`${year}-${month}-${day}`);

  return (
    isValidDate(newDate) &&
    parseInt(day) === newDate.getDate() &&
    parseInt(month) === newDate.getMonth() + 1 && // getMonth is 0 based
    parseInt(year) === newDate.getFullYear()
  );
}

export function isDateAfter(dateA, subtract, equals, unit = 'days') {
  let diff = date.getDateDiff(dateA, subtract, unit);
  return equals ? diff >= 0 : diff > 0;
}

export function isDateBefore(dateA, subtract, equals, unit = 'days') {
  let diff = date.getDateDiff(dateA, subtract, unit);
  return equals ? diff <= 0 : diff < 0;
}

export function isDateAfterNow(dateA, equals, unit = 'days') {
  return isDateAfter(dateA, new Date(), equals, unit);
}
